import React from 'react'
import { Link } from 'react-router-dom'

export default function SubscriptionCancelPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="glass-card p-8 text-center max-w-md">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Subscription Not Completed</h1>
        <p className="text-gray-500 dark:text-gray-400 mb-6">No worries — you can upgrade anytime.</p>
        <Link to="/practice" className="btn-primary text-sm py-2 px-6">
          Back to Practice
        </Link>
      </div>
    </div>
  )
}
